export default "__VITE_ASSET__iLgwIqeA__"